<template lang="pug">
.split-container.has-text-centered
	.qrcode-container
		.has-text-centered.color-black
			check-icon(size="5x")
		p.subtitle.has-text-centered(v-if="userState.subscription_active")
			strong(style="font-size:120%;") {{ $t('profile.active_subscription').toUpperCase() }}
		p.subtitle.has-text-centered(v-else-if="userState.trial_active")
			strong.padding-mobile-trial(style="font-size:120%;") {{ $t('profile.active_trial').toUpperCase() }}

		.subtitle.margin-top-md
			.columns.is-mobile.is-centered.is-vcentered.is-multiline.columns-no-padding-vertical
				.column.is-narrow.column-wide-mobile
					| {{ $t('profile.app_step1a') }}
				.column.is-narrow.no-padding-left
					img(src="/icon.png" alt="" draggable="false" style="width:2.2rem; display:block;")
				.column.is-narrow.no-padding-left
					strong {{ $t('profile.app_step1b') }}
				.column.is-narrow.no-padding-left
					| {{ $t('profile.app_step1c') }}
			.columns.is-mobile.is-centered.is-vcentered.is-multiline.columns-no-padding-vertical
				.column.no-padding-left(style="line-height:1.6")
					| {{ $t('profile.app_step1d') }}
		
		.app-container
			//-p.subtitle.has-text-centered(style="margin-bottom: 0.5rem;")
				strong(style="font-size:120%;")
					| {{ $t('profile.app_step1').toUpperCase() }}
			android-app
			ios-app
		p.subtitle.margin-top-md.has-text-centered(v-if="userQrcode")
			| {{ $t('profile.app_step2') }}
		.has-text-centered(v-if="userQrcode")
			qrcode(:value="userQrcode" :options="qrCodeOptions")
			countdown(v-if="counting" :time="60000" @end="handleCountdownEnd")
				template(slot-scope="props")
					| {{ $t('profile.app_step_seconds', { 'seconds': props.totalSeconds }) }}

		template(v-if="userState.trial_active")
			p.subtitle.margin-top-md.no-line-break-mobile.has-text-centered(style="margin-bottom:0rem;")
				strong(style="font-weight: 700;") {{ $t('profile.app_step3').toUpperCase() + ' ' }}
			p.subtitle.subtitle-payment(style="margin-bottom:0.5rem;")
				| {{ $t('profile.payment_info_to_continue1b') + ' ' }}
				span(style="font-weight: 700;")
					| {{ $t('profile.payment_info_to_continue2') + ' ' }}
				| {{ $t('profile.payment_info_to_continue3') }}
			p.subtitle.subtitle-payment(style="margin-bottom:0.5rem;")
				span(style="font-weight: 700;")
					| {{ $t('profile.payment_info_to_continue4') + ' ' }}
				br
				| {{ $t('profile.payment_info_to_continue5') }}
				ol(style="padding-left:1.1rem")
					li {{ $t('profile.payment_info_guide_1') }}
					li {{ $t('profile.payment_info_guide_2') }}
					li {{ $t('profile.payment_info_guide_3') }}
			p.subtitle.subtitle-payment
				| {{ $t('profile.payment_info_guide_4') }}
</template>

<script>
import { CheckIcon } from 'vue-feather-icons'

import AndroidApp from './app/AndroidApp.vue'
import IosApp from './app/IosApp.vue'

export default {
	components: {
		CheckIcon,
		AndroidApp,
		IosApp,
	},
	data() {
		return {
			counting: false
		}
	},
	computed: {
		userState() {
			return this.$store.state.user.userState
		},
		userQrcode() {
			return this.$store.state.user.userQrcode
		},
		qrCodeOptions() {
			const screenW = window.innerWidth

			return {
				width: screenW > 1024 ? 300 : 200
			}
		}
	},
	methods: {
		handleCountdownEnd() {
			this.counting = false
			this.$store.dispatch('user/getUserQrcode', this.accessToken).then(res => {
				this.counting = true
			}).catch(err => {
				if (err.response && err.response.status) {
					console.warn(err.response.status)
				}
			})
		}
	}
}
</script>

